<template>
  <div class="h-full">
    <div ref="swiperEl" class="swiper h-full">
      <div class="swiper-wrapper">
        <div
          v-for="(tabContent, i) in new Array(nbTabsToDisplay).fill('')"
          :key="i"
          class="swiper-slide h-full"
        >
          <slot :position="i % nbTabs" :isActive="activeTab == i"></slot>
        </div>
      </div>
      <!-- Pagination -->
      <!-- <div class="swiper-pagination"></div> -->
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { importSwiperJs } from './importSwiperJs';

const swiperReady = importSwiperJs();

export default defineComponent({
  props: {
    nbTabs: { type: Number, default: 3 },
    slidesPerView: { type: Number, default: 1 },
    allowTouchMove: { type: Boolean, default: true },
    loop: { type: Boolean, default: true },
    defaultTab: { type: Number, default: 0 },
    autoPlay: { type: [Boolean, Number], default: 3000 },
    isVertical: { type: Boolean, default: false }
  },
  data() {
    return { activeTab: 0, initiated: false, swiperInstance: null };
  },
  async mounted() {
    const Swiper = await swiperReady;
    this.initSlider(Swiper);
    this.slideTo(this.defaultTab);
    setTimeout(() => {
      this.initiated = true;
    }, 500);
  },
  methods: {
    initSlider(Swiper) {
      const params = {
        allowTouchMove: this.allowTouchMove,
        direction: this.isVertical ? 'vertical' : 'horizontal',
        loop: this.loop,
        slidesPerView: this.slidesPerView,
        autoplay: this.autoPlay
          ? {
              delay: typeof this.autoPlay === 'number' ? this.autoPlay : 3000,
              disableOnInteraction: false
            }
          : false,
        pagination: { el: '.swiper-pagination', clickable: true },
        on: {
          slideChange: () => {
            this.activeTab = this.swiperInstance.activeIndex;
          }
        }
      };

      this.swiperInstance = new Swiper(this.$refs.swiperEl, params);

      // Injection de style custom
      const styleEl = document.createElement('style');
      styleEl.innerHTML = `
        .swiper-pagination {
          margin-top: 10px;
          position: relative;
          width: max-content !important;
          --swiper-pagination-bullet-width: 6px;
          --swiper-pagination-bullet-height: 6px;
          --swiper-pagination-bullet-inactive-opacity: 1;
          --swiper-pagination-bullet-inactive-color: red;
        }
        .swiper-pagination-bullet {
          border: solid black 2px;
          background-color: transparent;
        }
        .swiper-pagination-bullet-active {
          background-color: black;
        }
      `;
      document.head.appendChild(styleEl);
    },
    slideTo(tabIndex) {
      this.swiperInstance?.slideTo(tabIndex, 300);
    },
    getActiveTab() {
      return this.activeTab;
    },
    updateSlider() {
      this.swiperInstance?.update();
    }
  },
  computed: {
    nbTabsToDisplay() {
      if (!this.loop) return this.nbTabs;
      return this.nbTabs * Math.max(this.minSlides - this.nbTabs + 1, 1);
    },
    minSlides() {
      return 5 * this.slidesPerView;
    }
  },
  watch: {
    activeTab(newValue) {
      if (this.initiated) this.$emit('tabChanged', newValue);
    },
    nbTabs() {
      this.updateSlider();
    },
    loop() {
      this.updateSlider();
    }
  }
});
</script>
